import {dateFilterKeys} from 'shared/lib/filterHelper';

export const STATUS_PAGE_FILTER_KEYS = [
    'is_active',
    'hide_banner',
    ...dateFilterKeys('created_at'),
];
